(function (Drupal, drupalSettings) {
  Drupal.behaviors.dropdown = {
    attach: function (context, settings) {
      const dropdowns = context.querySelectorAll(".acces-rapide");
      dropdowns.forEach((dropdown) => {
        if (!dropdown.dataset.dropdownProcessed) {
          dropdown.dataset.dropdownProcessed = "true";

          document.addEventListener("click", function () {
            document.querySelectorAll(".dropdown.open").forEach((el) => {
              el.classList.remove("open");
            });
          });

          document.addEventListener("scroll", function () {
            if (window.scrollY > 60) {
              document.querySelectorAll(".dropdown.open").forEach((el) => {
                el.classList.remove("open");
              });
            }
          });

          document.addEventListener("click", function (e) {
            if (e.target.matches(".dropdown label")) {
              e.stopPropagation();
              const parent = e.target.closest(".dropdown");
              document.querySelectorAll(".dropdown.open").forEach((el) => {
                if (el !== parent) {
                  el.classList.remove("open");
                }
              });
              parent.classList.toggle("open");
            }
          });
        }
      });
    },
  };
})(Drupal, drupalSettings);
